import React, { useEffect, useState } from 'react';
import PersianNumberInput from './NumberInput';
import PhoneLogin from '../../component/PhoneLogin';
import persianNumbers from '../../api/persianNumber';
import { Button } from 'flowbite-react';
import api from '../../api/api';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function BodyFatCalculator() {
  const [gender, setGender] = useState('female');
  const [neck, setNeck] = useState('');
  const [waist, setWaist] = useState('');
  const [hip, setHip] = useState('');
  const [height, setHeight] = useState('');
  const [weight, setWeight] = useState('');
  const [age, setAge] = useState('');
  const [results, setResults] = useState(null);
  const [token, setToken] = useState(null);
  const [name, setName] = useState('');
  const [verifName, setVerifName] = useState(false);
  const [userPhone, setUserPhone] = useState(
    '' || localStorage.getItem('phone')
  );
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('idle');
  const [resultId, setResultId] = useState('');
  console.log('userPhone', userPhone);
  const navigate = useNavigate();
  // Check localStorage on mount
  useEffect(() => {
    const savedToken = localStorage.getItem('aziAuthToken');
    if (savedToken) setToken(savedToken);
  }, []);

  const calculate = () => {
    const n = parseFloat(neck);
    const w = parseFloat(waist);
    const h = parseFloat(height);
    const hp = parseFloat(hip);
    const wt = parseFloat(weight);
    const a = parseFloat(age);

    if (!n || !w || !h || (gender === 'female' && !hp)) {
      setResults(null);
      return;
    }

    let navy = null;
    if (gender === 'male') {
      navy =
        495 / (1.0324 - 0.19077 * Math.log10(w - n) + 0.15456 * Math.log10(h)) -
        450;
    } else {
      navy =
        495 /
          (1.29579 - 0.35004 * Math.log10(w + hp - n) + 0.221 * Math.log10(h)) -
        450;
    }

    let deurenberg = null;
    if (wt && a) {
      const bmi = wt / Math.pow(h / 100, 2);
      const sex = gender === 'male' ? 1 : 0;
      deurenberg = 1.2 * bmi + 0.23 * a - 10.8 * sex - 5.4;
    }

    const clamp = (val) => Math.min(70, Math.max(2, val));

    const withRange = (val) => {
      if (val == null || isNaN(val)) return null;
      const low = clamp(val - 2).toFixed(1);
      const high = clamp(val - 1).toFixed(1);
      return `${persianNumbers(low)}% – ${persianNumbers(high)}%`;
    };

    setResults({
      navy: withRange(navy),
      deurenberg: withRange(deurenberg),
    });
  };

  const inputStyle =
    'mt-2 block w-full rounded-md border-0 py-1.5 text-main shadow-sm ring-1 ring-inset ring-main placeholder:text-main focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6';

  const baseButtonStyle =
    'px-4 py-2 border rounded font-medium text-main transition-colors duration-150';
  const activeButtonStyle = 'bg-blue-500 text-white border-blue-500';
  const inactiveButtonStyle =
    'bg-white text-main border-gray-300 hover:bg-gray-100';

  useEffect(() => {}, []);

  const handleSendResult = async () => {
    setLoading(true);
    const formdata = {
      name: name,
      gender: gender,
      age: age,
      waist: waist,
      hip: hip,
      height: height,
      weight: weight,
      bodyFat: results,
      phone: userPhone,
    };
    console.log(formdata);

    try {
      const res = await axios.post(
        'https://mcp.vahidafshari.com/webhook/721e8e9c-2cca-4fe8-a964-40c34141f397',
        formdata
      );

      setStatus('sent');
      setLoading(false);
      setResultId(JSON.parse(res.data[0]._id));
      console.log(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setVerifName(name.trim().length >= 3); // Enable only when name has 2+ characters
  }, [name]);

  return (
    <div className="mt-5 md:col-span-2 md:mt-0">
      {!token ? (
        <PhoneLogin
          onLogin={(newToken) => setToken(newToken)}
          setUserPhone={setUserPhone}
        />
      ) : (
        <div className="overflow-hidden shadow sm:rounded-md lg:w-1/2 m-auto p-4">
          <h2 className="text-lg font-bold mb-4">آنالیز بدن</h2>

          {/* If no results, show form */}
          {!results && (
            <>
              {/* Gender */}
              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">جنسیت</label>
                <div className="flex gap-2">
                  {['female', 'male'].map((g) => (
                    <button
                      key={g}
                      type="button"
                      className={`${baseButtonStyle} ${
                        gender === g ? activeButtonStyle : inactiveButtonStyle
                      }`}
                      onClick={() => setGender(g)}>
                      {g === 'female' ? 'خانم' : 'آقا'}
                    </button>
                  ))}
                </div>
              </div>

              {/* Inputs */}
              <div className="mb-4">
                <label>دور گردن (cm):</label>
                <PersianNumberInput
                  className={inputStyle}
                  value={neck}
                  onChange={(val) => setNeck(val)}
                />
              </div>
              <div className="mb-4">
                <label>دور کمر (cm):</label>
                <PersianNumberInput
                  className={inputStyle}
                  value={waist}
                  onChange={(val) => setWaist(val)}
                />
              </div>
              {gender === 'female' && (
                <div className="mb-4">
                  <label>دور باسن (cm):</label>
                  <PersianNumberInput
                    className={inputStyle}
                    value={hip}
                    onChange={(val) => setHip(val)}
                  />
                </div>
              )}
              <div className="mb-4">
                <label>قد (cm):</label>
                <PersianNumberInput
                  className={inputStyle}
                  value={height}
                  onChange={(val) => setHeight(val)}
                />
              </div>
              <div className="mb-4">
                <label>وزن (kg):</label>
                <PersianNumberInput
                  className={inputStyle}
                  value={weight}
                  onChange={(val) => setWeight(val)}
                />
              </div>
              <div className="mb-4">
                <label>سن:</label>
                <PersianNumberInput
                  className={inputStyle}
                  value={age}
                  onChange={(val) => setAge(val)}
                />
              </div>

              {/* Calculate Button */}
              <button
                className="bg-main hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full mb-4"
                onClick={calculate}>
                محاسبه
              </button>
            </>
          )}

          {/* Results */}
          {results && (
            <div className="mt-4">
              <div className="font-bold text-center">
                براساس اطلاعات داده شده شما به نظر میرسید درصد چربی بدن شما در
                بازه زیر قرار دارد
              </div>
              <p className="text-center mt-5 text-4xl"> {results.navy}</p>
              <div className="p-4 text-xl text-center">
                اگر دوست داری که نظر کوچ تغذیه رو در مورد بدن خودت بدونی و ازش
                یه پیشنهاد برای مسیر تناسب اندامت دریافت کنی، روی این دکمه بزن
              </div>

              <div>
                {status !== 'sent' ? (
                  <div>
                    <input
                      type="text"
                      onChange={(e) => setName(e.target.value)}
                      placeholder="نام خود را وارد کنید"
                      className="w-full mb-4 p-2 border rounded text-center focus:outline-none focus:ring-2 focus:ring-green-500"
                    />

                    <button
                      disabled={!verifName}
                      onClick={handleSendResult}
                      className={`w-full mb-4 py-2 px-4 rounded font-bold transition-all ${
                        verifName
                          ? 'bg-green-600 hover:bg-green-700 text-white shadow-lg'
                          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      }`}>
                      {loading ? (
                        <div class="flex items-center justify-center">
                          <div class="relative">
                            <div class="h-24 w-24 rounded-full border-t-8 border-b-8 border-gray-200"></div>
                            <div class="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-blue-500 animate-spin"></div>
                          </div>
                        </div>
                      ) : (
                        <span>دریافت پیشنهاد رایگان </span>
                      )}
                    </button>
                  </div>
                ) : (
                  <div
                    className="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md"
                    role="alert">
                    <div className="flex flex-col">
                      <div className="p-2 flex flex-row">
                        <svg
                          class="fill-current h-6 w-6 text-teal-500 mr-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20">
                          <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                        </svg>
                        <p className="font-bold text-right mb-3 px-3">
                          {name} عزیز، درخواست شما دریافت شد
                        </p>
                      </div>

                      <div>
                        <div className="flex flex-row">
                          <p dir="rtl" className="text-md">
                            بزودی و پس از آماده شدن آنالیز، به شما از طریق شماره{' '}
                            {userPhone}
                            اطلاع رسانی خواهد شد
                          </p>
                          <button
                            onClick={() => {
                              navigate(`/`);
                            }}
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                            متوجه شدم
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* You can also show deurenberg if needed */}
              {/* <p>Deurenberg estimate: {results.deurenberg || 'N/A'}</p> */}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
